import { useEffect, useState } from 'react';

import { ParamsDataFinancialPending } from 'utils/typeServices';

import TableDesk from './TableDesk';
import TableMobile from './TableMobile';
import NavTitle from 'components/views/NavTitle';

import { Content } from './styles';

type ParamsData = {
    typeInvoice: 'nextInv' | 'overdueInv' | 'paidInv';
    invList: Array<ParamsDataFinancialPending>;
}

const InvoiceContent = ({ typeInvoice, invList }: ParamsData) => {
    const [invDetails, setInvDetails] = useState<Array<Array<String>>>([]);

    useEffect(() => {
        let auxInvList: Array<Array<String>> = [];
        if (invList) {
            invList.map(({ DT_VENCIMENTO, DS_PLACA, NM_PRODUTO, DT_PERIDO_FIM, DT_PERIODO_INICIO, NM_TIPO_COBRANCA, VL_ATUALIZADO, VL_ORIGINAL, NM_FORMA_PGTO }) =>
                auxInvList.push([`${DT_VENCIMENTO}`, `${VL_ATUALIZADO}`, `${VL_ORIGINAL}`, NM_FORMA_PGTO, `${DS_PLACA || ''}`, `${NM_PRODUTO || ''}`, `${DT_PERIODO_INICIO ? `${new Date(DT_PERIODO_INICIO).toLocaleDateString('pt-BR')} até ${new Date(DT_PERIDO_FIM).toLocaleDateString('pt-BR')}` : ''} `, `${NM_TIPO_COBRANCA}`])
            )
            setInvDetails(auxInvList);
        }
    }, [invList]);

    return (
        <Content>
            <NavTitle
                title={typeInvoice === 'nextInv' ? 'Próxima fatura' : typeInvoice === 'overdueInv' ? 'Faturas vencidas' : 'Faturas pagas'}
                color={typeInvoice === 'nextInv' ? '#0AA8E3' : typeInvoice === 'overdueInv' ? '#FF0000' : '#97C93D'} />
            <TableDesk invDetailsList={invDetails} typeInvoice={typeInvoice} invDetailsListObj={invList} />
            <TableMobile invDetailsList={invList} typeInvoice={typeInvoice} />
        </Content>
    );
}

export default InvoiceContent;